import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Exception } from '@cargos/sprintpay-models';
import { take } from 'rxjs';
import { FileRequestService } from 'src/app/shared/services/file-handler.service';
import Swal from 'sweetalert2';

@Component({
    standalone: true,
    selector: 'app-file',
    templateUrl: './file.component.html',
    imports: [MatButtonModule],
})
export class FileComponent {
    @Input() set filesPath(filesPath: string[]) {
        this.files = filesPath;
    }
    @Input() set nameFiles(nameFiles: string[]) {
        this.names = nameFiles;
    }

    public names: string[];
    public files: string[];
    constructor(private fileRequestService: FileRequestService) {}

    downloadFile(nameFile: string): void {
        const path: string = this.files.find((path: string) => path.includes(nameFile)) ?? '';
        if (path.length) {
            this.fileRequestService
                .downloadFile(path, nameFile)
                .pipe(take(1))
                .subscribe({
                    error: (error: Exception) => {
                        Swal.fire({
                            title: error.title,
                            text: error.description,
                            icon: error.type,
                        });
                    },
                });
        }
    }
}
